var map = {
	"./auth/routes.js": "f10c",
	"./brand/routes.js": "c056",
	"./component/routes.js": "1140",
	"./home/routes.js": "c567",
	"./language/routes.js": "9c8e",
	"./layout/routes.js": "d161",
	"./page/routes.js": "3e3d",
	"./pageGroup/routes.js": "b013",
	"./role/routes.js": "c213",
	"./site/routes.js": "1453",
	"./siteImporter/routes.js": "1372",
	"./translation/routes.js": "bfdc",
	"./user/routes.js": "bdf5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ffe";